import React from 'react';
import styles from './styles.module.scss';

export default function FloorSelector({ floors, activeId, onSelect, reversed = true }) {
  if (!floors.length) return null;

  const displayFloors = reversed ? [...floors].reverse() : floors;

  return (
    <div className={styles.floorSelector}>
      <div className={styles.title}>Этажи</div>
      {displayFloors.map(floor => (
        <button
          key={floor.id}
          className={`${styles.floorBtn} ${activeId === floor.id ? styles.active : ''}`}
          onClick={() => onSelect(floor)}
        >
          {floor.name}
        </button>
      ))}
    </div>
  );
}
